// extracted by mini-css-extract-plugin
module.exports = {"width100":"y_dp h_dp","design3Pos":"y_s0 h_dT"};